import {
  QUESTION_MATRIX_SINGLE,
  QUESTION_MATRIX_MULTIPLE,
  QUESTION_MATRIX_BIPOLAR,
  QUESTION_MATRIX_NUMERIC_OPEN_ENDED,
  QUESTION_MATRIX_CONSTANT_SUM,
  QUESTION_MATRIX_OPEN_ENDED,
} from 'data/nodeTypes';

export const COLLAPSE_OPEN_KEY = 'COLLAPSE_OPEN_KEY';
export const AB_DEFAULT_REPETITIONS = 1;
export const AB_TYPE_MONADIC = 1;
export const AB_TYPE_SEQUENTIAL = 2;
export const AB_SEQUENTIAL_MIN_ITEMS = 2;
export const CONJOINT_DEFAULT_REPETITIONS = 2;
export const CONJOINT_DEFAULT_ALTERNATIVES = 2;
export const VAN_WESTENDORP_DEFAULT_REPETITIONS = 1;
export const LOOP_AND_MERGE_DEFAULT_REPETITIONS = 3;

export const MATRIX_TYPE_LIKERT = 1;
export const MATRIX_TYPE_BIPOLAR = 2;
export const MATRIX_ANSWER_TYPE_SINGLE = 3;
export const MATRIX_ANSWER_TYPE_MULTIPLE = 4;
export const MATRIX_TYPE_NUMERIC_OPEN_ENDED = 5;
export const MATRIX_TYPE_CONSTANT_SUM = 6;
export const MATRIX_TYPE_OPEN_ENDED = 7;

export const MATRIX_QUESTION_TYPES_ON_CHANGE = {
  [MATRIX_TYPE_LIKERT]: {
    [MATRIX_ANSWER_TYPE_SINGLE]: QUESTION_MATRIX_SINGLE,
    [MATRIX_ANSWER_TYPE_MULTIPLE]: QUESTION_MATRIX_MULTIPLE,
    [MATRIX_TYPE_BIPOLAR]: QUESTION_MATRIX_BIPOLAR,
    [MATRIX_TYPE_NUMERIC_OPEN_ENDED]: QUESTION_MATRIX_NUMERIC_OPEN_ENDED,
    [MATRIX_TYPE_CONSTANT_SUM]: QUESTION_MATRIX_CONSTANT_SUM,
    [MATRIX_TYPE_OPEN_ENDED]: QUESTION_MATRIX_OPEN_ENDED,
  },
  [MATRIX_TYPE_BIPOLAR]: {
    [MATRIX_ANSWER_TYPE_SINGLE]: QUESTION_MATRIX_SINGLE,
    [MATRIX_ANSWER_TYPE_MULTIPLE]: QUESTION_MATRIX_MULTIPLE,
    [MATRIX_TYPE_NUMERIC_OPEN_ENDED]: QUESTION_MATRIX_NUMERIC_OPEN_ENDED,
    [MATRIX_TYPE_CONSTANT_SUM]: QUESTION_MATRIX_CONSTANT_SUM,
    [MATRIX_TYPE_OPEN_ENDED]: QUESTION_MATRIX_OPEN_ENDED,
  },
  [MATRIX_TYPE_OPEN_ENDED]: {
    [MATRIX_ANSWER_TYPE_SINGLE]: QUESTION_MATRIX_SINGLE,
    [MATRIX_ANSWER_TYPE_MULTIPLE]: QUESTION_MATRIX_MULTIPLE,
    [MATRIX_TYPE_NUMERIC_OPEN_ENDED]: QUESTION_MATRIX_NUMERIC_OPEN_ENDED,
    [MATRIX_TYPE_CONSTANT_SUM]: QUESTION_MATRIX_CONSTANT_SUM,
    [MATRIX_TYPE_BIPOLAR]: QUESTION_MATRIX_BIPOLAR,
  },
  [MATRIX_TYPE_NUMERIC_OPEN_ENDED]: {
    [MATRIX_ANSWER_TYPE_SINGLE]: QUESTION_MATRIX_SINGLE,
    [MATRIX_ANSWER_TYPE_MULTIPLE]: QUESTION_MATRIX_MULTIPLE,
    [MATRIX_TYPE_BIPOLAR]: QUESTION_MATRIX_BIPOLAR,
    [MATRIX_TYPE_CONSTANT_SUM]: QUESTION_MATRIX_CONSTANT_SUM,
    [MATRIX_TYPE_OPEN_ENDED]: QUESTION_MATRIX_OPEN_ENDED,
  },
  [MATRIX_TYPE_CONSTANT_SUM]: {
    [MATRIX_ANSWER_TYPE_SINGLE]: QUESTION_MATRIX_SINGLE,
    [MATRIX_ANSWER_TYPE_MULTIPLE]: QUESTION_MATRIX_MULTIPLE,
    [MATRIX_TYPE_BIPOLAR]: QUESTION_MATRIX_BIPOLAR,
    [MATRIX_TYPE_NUMERIC_OPEN_ENDED]: QUESTION_MATRIX_NUMERIC_OPEN_ENDED,
    [MATRIX_TYPE_OPEN_ENDED]: QUESTION_MATRIX_OPEN_ENDED,
  },
};

export const MIN_ALLOWED_TEXT_LENGTH = 2;
export const MAX_ALLOWED_TEXT_LENGTH = 500;
export const LOOP_AND_MERGE_PROFILING_MAX_VALUES = 100;
